import { render, staticRenderFns } from "./ViewUrl.vue?vue&type=template&id=428627c2"
import script from "./ViewUrl.vue?vue&type=script&lang=js"
export * from "./ViewUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports